import React from "react";
import PageTitle from "../PageTitle";
import { doRequest, dovocalRequest } from "../../helper";
import $, { valHooks } from "jquery";
import { NavLink } from "react-router-dom";
import LazyLoad from "react-lazyload";
import axios from "axios";
import { saveAs } from "file-saver";
let newevent = [
  "sashaktnari",
  "swachhbharat",
  "promotingincredibleindia",
  "vocalforlocal",
  "digitalpayment",
];

export default class SwachhteerthModeration extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: [],
      response: null,
      postCount: 0,
      status: "",
      points: "processed",
      // lastEvaluatedKey: "",
      loadMoreDisplay: false,
      selectedPhotos: [],
      isChecked: false,
      limit: 100,
      page: 1,
      selectedButton: null,
      popupImageUrl: "",
      postDetail: {},
      selectedPostActivity: "",
    };
    this.rejectupdate = this.rejectupdate.bind(this);
    this.getGallerydata = this.getGallerydata.bind(this);
    this.selectToggle = this.selectToggle.bind(this);
  }

  componentDidMount() {
    var status = this.props.match.params.status;
    if (!status) {
      status = "processed";
    }
    this.getGallerydata("loadmore", this.state.page, status);
  }

  getGallerydata(loadmore, pageno, status, point) {
    $("#loader").css({ display: "block" });
    var ref = this;
    ref.setState({
      status: status,
    });

    if (point == "disable") {
      ref.setState({
        points: "rejected",
      });
    }
    if (point == "enable") {
      ref.setState({
        points: "processed",
      });
    }
    if (!loadmore) {
      ref.setState({ items: [], page: 1 });
    }
    var requestOptions = {
      method: "GET",
      redirect: "follow",
    };
    fetch(
      `https://d1zez9d7l5hgkm.cloudfront.net/v1/moderation/swachhpostlilst?page=${
        pageno ? pageno : this.state.page
      }&limit=${this.state.limit}&status=${status}&v=${Math.random()}`,
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        if (
          result &&
          result["resultFlag"] == "1" &&
          result["resultFlag"] == 1
        ) {
          if (status == "rejected") {
            if (loadmore) {
              ref.setState(
                {
                  items: [...ref.state.items, ...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            } else {
              ref.setState(
                {
                  items: [...result.response],
                },
                () => {
                  $("#loader").css({ display: "none" });
                }
              );
            }
          } else {
            ref.setState(
              {
                items: [...ref.state.items, ...result.response],
              },
              () => {
                $("#loader").css({ display: "none" });
              }
            );
          }
          if (result.response.length.toString() >= this.state.limit) {
            ref.setState({
              loadMoreDisplay: true,
            });
          } else {
            ref.setState({
              loadMoreDisplay: false,
            });
          }
        }
      })
      .catch((error) => console.log("error", error));
  }

  rejectupdate(id, status) {
    let confirm = window.confirm(
      "Are you sure you want to disable this image ?"
    );
    if (confirm) {
      var ref = this;
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        id: id,
        status: status,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(
        "https://d1zez9d7l5hgkm.cloudfront.net/v1/swachhteerthpost/update",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          console.l;
          if (result && result["resultFlag"] == 1) {
            $("#post_" + id).hide();
          }
        })
        .catch((error) => console.log("error", error));
    }
    // $("#loader").css({ display: "block" });
  }

  loadMoreData = () => {
    this.setState({
      page: this.state.page + 1,
    });
    $("#loader").css({ display: "block" });
    this.getGallerydata("loadmore", this.state.page + 1, this.state.status);
    $("#loader").css({ display: "none" });
  };

  selectToggle() {
    if ($(".allChecked").length > 0) {
      $(".multi_select").prop("checked", false);
      $(".multi_select").removeClass("allChecked");
    } else {
      $(".multi_select").prop("checked", true);
      $(".multi_select").addClass("allChecked");
    }
  }

  UnselectChekbox = () => {
    this.setState({ selectedPhotos: [] });
  };

  render() {
    var bread = "Swachh Teerth / Moderation (Disabled Posts)";
    var pagelink = "/viksitbharatselfie/moderation";
    if (this.state.status == "rejected") {
      bread = "Swachh Teerth/ Moderation (Disabled Posts)";
      pagelink += "/disabled";
    } else if (this.state.status == "processed") {
      bread = "Swachh Teerth/ Moderation (Enabled Posts)";
      pagelink += "/enabled";
    } else {
      bread = "Swachh Teerth/ Moderation (Enabled Posts)";
      pagelink += "/disabled";
    }
    var items = this.state.items;
    var links = [
      {
        link: "/swachhteerth/moderation/disabled",
        name: "View Disabled Posts",
      },
      {
        link: "/swachhteerth/moderation/enabled",
        name: "View Active Posts",
      },
    ];
    var pagination = [];
    if (this.state.response && countdata) {
      var countdata = this.state.response.countdata;
      var pages = Math.ceil(countdata.Count / this.state.limit);

      for (var i = 1; i <= pages; i++) {
        pagination.push(
          <span key={i}>
            <NavLink to={pagelink + "/" + i} className="btn btn-primary btn-xs">
              {i}
            </NavLink>
            &nbsp;
          </span>
        );
      }
    }

    const { selectedPhotos } = this.state;
    const { isChecked } = this.state;
    return (
      <div>
        <PageTitle
          title="#Swachh Teerth"
          bread={bread}
          //   links={links}
          Count={this.state.postCount}
        />
        <div className="wrapper wrapper-content">
          <br />
          <div className="form-inline form_right">
            <div>
              <button
                className={
                  this.state.points === "processed"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata("", 1, "processed", "enable")
                }
              >
                Enable
              </button>
              <button
                className={
                  this.state.points === "rejected"
                    ? `btn btn-success btn-rounded`
                    : `btn btn-primary btn-rounded`
                }
                onClick={() =>
                  this.getGallerydata("", 1, "rejected", "disable")
                }
              >
                Disable
              </button>
            </div>
          </div>
          <br />
          <div className="row">
            <div className="col-lg-12">
              <div className="kamal_list">
                <p
                  id="nodatafound"
                  style={{
                    display: "none",
                    textAlign: "center",
                    position: "relative",
                    left: "50%",
                    transform: "translateX(-50%)",
                  }}
                >
                  No Data Found
                </p>
                {Array.isArray(items) &&
                  items.map((value, index) => {
                    return (
                      <div class="file-box" key={index} id={"post_" + value.id}>
                        <div class="file">
                          <a href="javascript:void(0);">
                            <span class="corner"></span>
                            <LazyLoad>
                              <div class="image" style={{ height: "auto" }}>
                                <div className="user_image_list">
                                  <ul>
                                    <li>
                                      <a>
                                        <img src={value.image_path} alt="" />
                                      </a>
                                    </li>
                                  </ul>
                                </div>
                                {/* <div className="image_caption vbactivity"> */}
                                <div className="image_caption">
                                  <a
                                    href="javascript:void(0);"
                                    className="btn btn-warning btn-circle"
                                    onClick={() => {
                                      this.rejectupdate(value.id, "rejected");
                                    }}
                                    type="button"
                                    title="rejected"
                                  >
                                    <i className="fa fa-times"></i>
                                  </a>
                                </div>
                              </div>
                            </LazyLoad>
                            <div class="file-name">
                              {value.activity_name ? value.activity_name : ""}
                              <br />

                              <small>
                                Added:{" "}
                                {value.created_at ? value.created_at : ""}
                              </small>
                            </div>
                          </a>
                        </div>
                      </div>
                    );
                  })}
              </div>
            </div>
            {this.state.loadMoreDisplay && (
              <button
                style={{
                  position: "relative",
                  left: "50%",
                  transform: "translateX(-50%)",
                  padding: "10px 18px",
                }}
                type="button"
                onClick={this.loadMoreData}
              >
                Load More
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/SwachhTeerth/Moderation.jsx